import React, { PropTypes } from 'react';
import NewsEditForm from '../NewsEditForm';

class NewsNew extends React.Component {
  static propTypes = {
    fetch: PropTypes.func.isRequired
  };

  componentWillMount() {
    this.props.fetch();
  }

  render() {
    return (
      <NewsEditForm title="Create News"/>
    );
  }
}

export default NewsNew;




// WEBPACK FOOTER //
// ./src/components/News/NewsNew/NewsNew.jsx